export const aboutText = [
	{
		title: "About my blog",
		text: "I will post things like blogs, thoughts, and sometimes my life anecdotes here. If you find anything interesting, please do not hestitate to share and comment."
	},
	{
		title: "About my background",
		text: "Rather than having an education in Computer Science, at 18 years old without knowing where my passion was, I decided to pursue a bachelor's degree in Mathematics from NYU. As a person who built my own pc and always want to customize any configurations related to personsal preferences, I realize that software engineer is exactly the place I want to be because it gives me full control over the things I want to build",
	},
];
